import { render, staticRenderFns } from "./orders-statistics-modal.vue?vue&type=template&id=1efbf970&scoped=true&"
import script from "./orders-statistics-modal.js?vue&type=script&lang=js&"
export * from "./orders-statistics-modal.js?vue&type=script&lang=js&"
import style0 from "./orders-statistics-modal.scss?vue&type=style&index=0&id=1efbf970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efbf970",
  null
  
)

export default component.exports